(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  var stickyBar = document.getElementById('mobile-sticky-atc');
  if (!stickyBar) return;

  var nativeBtn = document.querySelector('[name="add"]') ||
    document.querySelector('.product-form__cart-submit') ||
    document.querySelector('.add-to-cart');
  if (!nativeBtn) return;

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (!entry.isIntersecting) {
      stickyBar.classList.add('is-visible');
      stickyBar.setAttribute('aria-hidden', 'false');
    } else {
      stickyBar.classList.remove('is-visible');
      stickyBar.setAttribute('aria-hidden', 'true');
    }
  }, { threshold: 0 });

  observer.observe(nativeBtn);

  document.getElementById('mobile-sticky-atc-btn').addEventListener('click', function () {
    if (nativeBtn && !nativeBtn.disabled) {
      nativeBtn.click();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
